export default __webpack_public_path__ + "static/assets/med_spheric_solid_01.af5f40d6.png";